<template lang="pug">
.ExcelLayerObject
  .ExcelLayerObject-header
    h2 {{ title || "Редактировать запись" }}
    .ExcelLayerObject-close
      button.Btn.BtnIcon(@click='cancel')
        i.Icon.IconClose
  .ExcelLayerObject-body
    template(v-for='header in headers')
      .ExcelLayerObject-item.Item(v-if='header.name_in_table !== "id" || params.id')
        .Item-label {{ header.rus_name || header.id }}
        .Item-field
          input.TextInput.TextInput--block(
            type='text',
            v-model='params[header.name_in_table]',
            :disabled='header.name_in_table === "id"'
          )
  .ExcelLayerObject-footer
    .ExcelLayerObject-left
      button#ConfirmationPopup_submit.Btn.Btn--blue.Btn--light(@click='save') Сохранить
      button#ConfirmationPopup_cancel.Btn.Btn--grey.Btn--light(@click='cancel') Отмена
    .ExcelLayerObject-right(v-if='item && item.id')
      button.Btn.Btn--outline.BtnIcon.Btn--remove.Btn--light(@click='removeObject')
        i.Icon.IconRemove
        | Удалить
</template>

<script>
export default {
  name: 'excel-layer-object',

  props: {
    title: String,
    headers: {
      type: Array,
      default: () => {
        return []
      }
    },
    item: Object,
    layerId: String
  },

  data() {
    return {
      params: {},
      isInProcess: false
    }
  },

  computed: {
    isStreamLine() {
      return this.headers.findIndex((v) => v.id === 'sinkpoint') > -1
    }
  },

  mounted() {
    if (this.item) {
      this.params = {
        ...this.item
      }
    } else {
      this.headers.forEach((v) => {
        this.params[v.name_in_table] = ''
      })
      this.params = { ...this.params }
    }
  },

  methods: {
    save() {
      if (this.isInProcess) {
        return
      }

      if (!this.params.id) {
        delete this.params.id
      }
      if (this.isStreamLine && this.item) {
        if (this.item.sinkpoint !== this.params.sinkpoint || this.item.sourcepoint !== this.params.sourcepoint || !this.layerId) {
          this.params.distance = 0
        }
      }

      this.isInProcess = true
      this.$ui.toast.show({ text: 'Сохранение', type: 'progress', time: 60000 })
      this.$store
        .dispatch('updateExcelObject', {
          id: this.layerId,
          params: this.params
        })
        .then((v) => {
          this.$ui.toast.show({ text: 'Запись сохранена', time: '5000', type: 'success' })
          this.$ui.popup.ok()
        })
        .catch((e) => {
          console.log(e, this.item)
          this.$ui.toast.show({ text: 'Ошибка сохранения записи', time: '5000', type: 'error' })
        })
        .finally(() => {
          this.isInProcess = false
        })
    },

    cancel() {
      this.$ui.popup.hide()
    },

    removeObject() {
      if (this.isInProcess) {
        return
      }

      this.isInProcess = true
      this.$ui.toast.show({ text: 'Удаление', type: 'progress', time: 60000 })
      this.$store
        .dispatch('deleteExcelObject', {
          id: this.layerId,
          obj_ids: this.item.id
        })
        .then((v) => {
          this.$ui.toast.show({ text: 'Запись удалена', time: '5000', type: 'success' })
          this.$ui.popup.ok()
        })
        .catch((e) => {
          this.$ui.toast.show({ text: 'Ошибка удаления записи', time: '5000', type: 'error' })
        })
        .finally(() => {
          this.isInProcess = false
        })
    }
  }
}
</script>

<style lang="scss">
@import '~base';
.Popup .ExcelLayerObject {
  --excelLayerFooterBorder: #{$grey};
  --excelLayerClose: #{$grey2};
  --excelLayerBtnBg: #{$grey6};
  --excelLayerBtnColor: #{$black5};
}

.Popup[data-theme='dark'] .ExcelLayerObject {
  --excelLayerFooterBorder: #{$grey2};
  --excelLayerClose: #{$grey1};
  --excelLayerBtnBg: #{$grey6};
  --excelLayerBtnColor: #{$black5};
}
</style>
<style scoped lang="scss">
@import '~base';
.ExcelLayerObject {
  color: var(--basicText);

  &-header {
    padding: 25px 30px 15px;

    h2 {
      margin-bottom: 0;
      font-size: 16px;
      text-transform: uppercase;
    }
  }

  &-close {
    position: absolute;
    top: 10px;
    right: 15px;

    .Icon {
      font-size: 14px;
    }
  }

  &-main {
    padding: 25px 35px 30px;
  }

  &-item {
    display: flex;
    align-items: center;
  }

  .Item {
    margin-bottom: 24px;
    padding: 0 37px;

    &-label {
      flex: 0 0 35%;
      padding-right: 15px;
      font-size: 12px;
      line-height: 14px;
      text-align: right;
    }

    &-field {
      flex: 0 0 65%;
    }
  }

  &-body {
    max-height: calc(90vh - 115px);
    overflow: auto;
  }

  &-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 35px;
    border-top: 1px solid var(--excelLayerFooterBorder);

    div {
      display: flex;
      align-items: center;
    }

    .Btn {
      min-width: 155px;

      & + .Btn {
        margin-left: 10px;
      }

      .Icon {
        font-size: 16px;
        margin-right: 10px;
      }

      &--cancel {
        color: var(--colorSettingsBtnColor);
        background: var(--colorSettingsBtnBg);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/ExcelLayerObject.vue